import React, { useCallback, useEffect, useRef, useState } from 'react'
import { PanelFooter } from '../../../../components/Panel/PanelFooter';
import { IComboBoxOption, IComboBox, Panel, PanelType, TextField } from '@fluentui/react';
import { IResponsePost } from '../../../../Interfaces/base/IResponse';
import { PanelHeader } from '../../../../components/Panel/PanelHeader';
import { ComboBoxIDS } from '../../../../components/generic/ComboBoxIDS';
import IdicadorProgress from '../../../../components/generic/IndicadorProgress';
import { MensajeBar } from '../../../../components/generic/ManejoResponseMessage/MessageBar';
import { IFilterEquipo, IPostCrearActividad } from '../../../../Interfaces/IPERC/IActividad';
import EquipoService from '../../../../services/Iperc/EquipoService';
import ActividadService from '../../../../services/Iperc/ActividadService';

export const PanelCrearActividad = (props: any) => {
    const controllerRef = useRef<AbortController>(new AbortController());
    const [request, setRequest] = useState<IPostCrearActividad>(null!);

    const [response, setResponse] = useState<IResponsePost>(null!);
    const [isSend, setIsSend] = useState(false);

    const [dataRequest, setDataRequest] = useState<IFilterEquipo>({
        search: "",
    });
    const [selectedKeys, setSelectedKeys] = useState("");

    const postCrearActividad = () => {
        LimpiarResponse();
        //setIsSend(true);
        ActividadService
            .postCrearActividad(request)
            .then((res) => {
                if (res.status === 200) {
                    // setResponse(res.data.response);
                    setResponse({
                        codigoMensaje: 1,
                        mensaje: "Registro realizado",
                    });
                    //getData();
                    //---> props.onRenderTable()
                    setIsSend(false);
                    setTimeout(() => {
                        setRequest(null!)
                        setDataRequest({ ...dataRequest, search: "" })
                        props.onDismiss()
                    }, 2000);


                } else {
                    setIsSend(false);
                    setResponse({
                        codigoMensaje: 3,
                        mensaje: "No fue posible realizar el registro",
                    });
                }
            })
            .catch((err) => {
                setIsSend(false);
                setResponse({
                    codigoMensaje: 3,
                    mensaje: "Error al realizar el registro",
                });
            });
    };

    const onRenderHeader = useCallback(
        () => (
            <>
                <PanelHeader
                    nameIconHeader="add"
                    textHeader={`Actividades`}
                    subTextHeader={`Agregar Actvidad`}
                />
            </>
        ),
        []
    );
    const onRenderFooter = useCallback(
        () => (
            <>
                <PanelFooter
                    texto="Agregar"
                    onClick={() => {
                        postCrearActividad();
                    }}
                    onDismiss={() => {
                        props.onDismiss();
                    }}
                />
            </>
        ),
        [postCrearActividad, request]
    );

    const onChangeTextField = (
        event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
        newValue?: string
    ) => {
        if (newValue) {
            setRequest({ ...request, nombre: newValue });
        }
    };

    const [equipoModeloCombo, setEquipoModeloCombo] = useState<IComboBoxOption[]>(
        []
    );

    const comboBoxRefModeloEquipos = useRef<IComboBox>(null);

    const onClickComboModeloEquipos = () =>
        comboBoxRefModeloEquipos.current?.focus(true);

    const _openOptionModeloEquipos = useCallback(
        () => comboBoxRefModeloEquipos.current?.focus(true),
        []
    );

    const _onkeyUpSearchModeloEquipo = (
        event: React.KeyboardEvent<IComboBox>
    ) => {
        _openOptionModeloEquipos();
        let { value } = event?.target as HTMLInputElement;
        setDataRequest({ ...dataRequest, search: value });
    };


    // const _onChangEquipo = (
    //     event: React.FormEvent<IComboBox>,
    //     option?: IComboBoxOption
    // ) => {
    //     if (event !== undefined) {
    //         if (option) {
    //             let data = (prevSelectedKeys: any[]) =>
    //                 option.selected
    //                     ? [...prevSelectedKeys, option!.key as string]
    //                     : prevSelectedKeys.filter((k) => k !== option!.key);
    //             setSelectedKeys(data);
    //         }
    //     }
    // };

    const _onChangEquipo = (
        event: React.FormEvent<IComboBox>,
        option?: IComboBoxOption
    ) => {
        if (event !== undefined) {
            if (option) {
                setRequest({ ...request, equipoId: option.key.toString() });
                setSelectedKeys(option.key.toString())
            }
        }
    };

    const postComboEquipoModelo = (data: IFilterEquipo) => {
        controllerRef.current?.abort()
        const newAbortController = new AbortController();
        controllerRef.current = newAbortController
        EquipoService.postListarComboEquipo(data, newAbortController).then((res) => {
            if (res.status === 200) {
                setEquipoModeloCombo(res.data);
            }
        });
    };

    const LimpiarResponse = () => {
        setResponse(null!);
    };

    useEffect(() => {
        if (!props.isOpen) {
            LimpiarResponse();
            props.onRefreshTable();
            setRequest(null!);
        }
    }, [props.isOpen]);

    useEffect(() => {
        if (props.isOpen) {
            postComboEquipoModelo(dataRequest);
        }
    }, [dataRequest, props.isOpen]);

    return (
        <>
            <Panel
                type={PanelType.medium}
                onRenderHeader={onRenderHeader}
                onRenderFooter={onRenderFooter}
                isFooterAtBottom
                isOpen={props.isOpen}
                onDismiss={props.onDismiss}
            >
                <>
                    <MensajeBar ocultar={() => LimpiarResponse()} response={response} />
                    <IdicadorProgress subText="Registrando Datos" isSend={isSend} />
                    <div className="ms-Grid" dir="ltr">
                        <div
                            style={{
                                margin: "30px 0px",
                                width: "100%",
                                height: "auto",
                                padding: "15px 0px",
                            }}
                        >
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                                    <br />
                                    <br />
                                    <TextField
                                        label="Nombre de la Actividad:"
                                        underlined
                                        required
                                        placeholder="Escribir aquí"
                                        onChange={onChangeTextField}
                                    />
                                </div>
                            </div>
                            <br />
                            <br />
                            <div className="ms-Grid" dir="ltr">
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm12 ms-lg12">
                                        <ComboBoxIDS
                                            title="Equipo:"
                                            componentRef={comboBoxRefModeloEquipos}
                                            KeyUp={_onkeyUpSearchModeloEquipo}
                                            onClick={onClickComboModeloEquipos}
                                            options={equipoModeloCombo}
                                            useComboBoxAsMenuWidth
                                            // multiSelect
                                            onChange={_onChangEquipo}
                                            placeholder='Seleccione un equipo'
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </>
            </Panel>
        </>
    );
};
